
export const environment = {
  production: false,
  baseUrl: 'https://stage-service.onechat.ai',
  apiUrl: 'https://stage-service.onechat.ai',

  baseUrlLogin: 'https://stage-mvp.onechat.ai',
};



// WEBPACK FOOTER //
// /Users/igor/Projects/onechat/admin-dashboard/src/environments/environment.ts